import update from 'immutability-helper';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { localStore } from 'ui/utils/localStore';
import actions from './action';

export const CLICKS = 'appsClickCount';

export interface IReducerState {
  currentApp: string;
  isDP360Collapsed: boolean;
  [CLICKS]: number;
}

const getPersistedState = (key: string, defaultValue: any) => {
  const value = localStore.getItem(key);
  // to handle falsy value if boolean (comparing undefined and null)
  if (value == null) {
    return defaultValue;
  }
  return value;
};

const persistState = (key: string, value: any) => {
  localStore.setItem(key, value);
};

const getPersistedCollapseState = (): boolean => {
  const isDP360Collapsed = localStore.getItem<boolean>('isDP360Collapsed');
  if (isDP360Collapsed === null) {
    return true;
  }

  return isDP360Collapsed === true;
};

const persistCollapseState = (isDP360Collapsed: boolean): void => {
  localStore.setItem<boolean>('isDP360Collapsed', isDP360Collapsed);
};

const INITIAL_STATE: IReducerState = {
  currentApp: localStore.getItem<string>('DP360CurrentApp') || 'summary',
  isDP360Collapsed: getPersistedCollapseState(),
  appsClickCount: getPersistedState(CLICKS, 0),
};

const reducer = reducerWithInitialState<IReducerState>(INITIAL_STATE)
  .case(actions.setCurrentApp, (state, { appName }) => {
    localStore.setItem<string>('DP360CurrentApp', appName);
    return update(state, {
      currentApp: {
        $set: appName,
      },
    });
  })
  .case(actions.toggleSidebar, state => {
    const prevState = !!state.isDP360Collapsed;
    persistCollapseState(!prevState);
    return update(state, {
      isDP360Collapsed: {
        $set: !prevState,
      },
    });
  })
  .case(actions.setSidebarState, (state, { set }) => {
    const isDP360Collapsed = set === 'close';
    persistCollapseState(isDP360Collapsed);
    return update(state, {
      isDP360Collapsed: {
        $set: isDP360Collapsed,
      },
    });
  })
  .case(actions.incrementAppsClickCount, state => {
    const clicksCount = getPersistedState(CLICKS, 0);
    const newCount = clicksCount + 1;
    persistState(CLICKS, newCount);
    return update(state, {
      [CLICKS]: {
        $set: newCount,
      },
    });
  })
  .build();

export default reducer;
